"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "uppercase font-bold" };
const _hoisted_2 = {
    key: 0,
    class: "my-4 flex flex-wrap gap-2"
};
const _hoisted_3 = { class: "p-2" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-refresh" }, null, -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "text-2xl" };
const _hoisted_9 = {
    key: 1,
    class: "my-4"
};
const _hoisted_10 = { class: "uppercase font-bold my-4" };
const _hoisted_11 = { class: "flex justify-end items-center" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-refresh" }, null, -1);
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "text-2xl" };
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("./ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
const i18n_1 = require("../common/i18n");
const vue_router_1 = require("vue-router");
const customersStore_1 = require("../stores/customers/customersStore");
const securityStore_1 = require("../stores/security/securityStore");
const userStore_1 = require("../stores/user/userStore");
const toastStore_1 = require("../stores/toast/toastStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SwitchCustomerModal',
    props: {
        isSwitchCustomerModalOpen: { type: Boolean }
    },
    emits: ["update:isSwitchCustomerModalOpen"],
    setup(__props, { emit }) {
        var _a, _b, _c, _d, _e;
        const props = __props;
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const userStore = (0, userStore_1.useUserStore)();
        const customersStore = (0, customersStore_1.useCustomersStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const currentUser = (0, vue_3.computed)(() => securityStore.authenticatedUser);
        const customerQuery = (0, vue_3.computed)(() => {
            const filters = {};
            switchCustomerListFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            let order = `order[${sortBy.value}]`;
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                [order]: sortDesc.value ? "desc" : "asc",
                ...filters,
            };
        });
        const sortBy = (0, vue_3.ref)("customerName");
        const sortDesc = (0, vue_3.ref)(false);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(10);
        const tableKey = (0, vue_3.ref)(0);
        const switchCustomerListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id", "ID", "navbar")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
                sortable: true,
                filterable: true,
            },
            {
                key: "customerName",
                label: (_b = (0, i18n_1.trans)("name", "Name", "navbar")) !== null && _b !== void 0 ? _b : "Name",
                value: "customerName",
                sortable: true,
                filterable: true
            },
            {
                key: "department",
                label: (_c = (0, i18n_1.trans)("department", "Department", "navbar")) !== null && _c !== void 0 ? _c : "Department",
                value: "department",
                sortable: true,
                filterable: true
            },
            {
                key: "customerCountryCode",
                label: (_d = (0, i18n_1.trans)("country_code", "Country code", "navbar")) !== null && _d !== void 0 ? _d : "Country code",
                value: "customerCountryCode",
                sortable: true,
                filterable: true
            },
            {
                key: "customerGroup",
                label: (_e = (0, i18n_1.trans)("customer_group", "Customer group", "navbar")) !== null && _e !== void 0 ? _e : "Customer group",
                value: "customerGroup",
                sortable: true,
                filterable: true
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const toggleSwitchCustomerModal = async () => {
            emit("update:isSwitchCustomerModalOpen", !props.isSwitchCustomerModalOpen);
        };
        const switchCustomer = async (customerId) => {
            if (!currentUser.value)
                return;
            // Ha ugyanarra a customerre váltanánk, ne csináljunk semmit, csak jelezzük.
            if (currentUser.value.customer && currentUser.value.customer.iri === customerId) {
                toastStore.addToast({
                    message: (0, i18n_1.trans)("customer_already_set", "You are already using this customer.", "switch_customer_modal"),
                    type: "info",
                    timer: 5,
                });
                return;
            }
            await userStore.updateUser(router, { customer: customerId }, currentUser.value.id);
            toggleSwitchCustomerModal();
            await securityStore.refreshToken(router);
            await securityStore.checkAuth(router);
            toastStore.addToast({
                message: (0, i18n_1.trans)("customer_switch_success", "Customer switched successfully!", "switch_customer_modal"),
                type: "success",
                timer: 5,
            });
        };
        const isFavoriteCustomer = (customer) => {
            if (!currentUser.value)
                return false;
            return currentUser.value.favoriteCustomerIds.includes(customer.id);
        };
        const toggleFavouriteCustomer = async (customer) => {
            if (!currentUser.value)
                return;
            const favoriteCustomerIds = Array.isArray(currentUser.value.favoriteCustomerIds) ? [...currentUser.value.favoriteCustomerIds] : [];
            const index = favoriteCustomerIds.indexOf(customer.id);
            if (index === -1) {
                favoriteCustomerIds.push(customer.id);
            }
            else {
                favoriteCustomerIds.splice(index, 1);
            }
            await userStore.updateUser(router, { favoriteCustomerIds }, currentUser.value.id);
            currentUser.value.favoriteCustomerIds = favoriteCustomerIds;
            await userStore.getFavouriteCustomers(router);
        };
        (0, vue_3.watch)(() => props.isSwitchCustomerModalOpen, (open) => {
            if (!open) {
                // Modal bezáráskor reset minden.
                customersStore.reset();
                switchCustomerListFields.value = switchCustomerListFields.value.map((filter) => {
                    if (filter.filterable) {
                        return { ...filter, filterValue: "" };
                    }
                    return filter;
                });
                page.value = 1;
                tableKey.value++;
                userStore.favouriteCustomers = [];
            }
            else {
                // Modal megnyitáskor betöltjük a kedvenc ügyfeleket.
                userStore.getFavouriteCustomers(router);
            }
        });
        (0, vue_3.watch)(customerQuery, async () => {
            // Ha a filterek üresek, mindent resetelünk.
            const hasFilters = switchCustomerListFields.value.some((filter) => filter.filterable && !!filter.filterValue && String(filter.filterValue).length > 0);
            if (!hasFilters) {
                customersStore.reset();
                return;
            }
            await customersStore.getCustomers(router, customerQuery.value);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                title: (0, vue_2.unref)(i18n_1.trans)('switch_customer', 'Switch Customer', 'switch_customer_modal'),
                "is-open": __props.isSwitchCustomerModalOpen,
                onClose: toggleSwitchCustomerModal
            }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("favourite_customers", "Favourite Customers", "switch_customer_modal")), 1),
                    ((0, vue_2.unref)(userStore).favouriteCustomers.length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(userStore).favouriteCustomers, (customer) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: customer.id,
                                    class: "flex items-center bg-gray"
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(customer.id) + " - " + (0, vue_2.toDisplayString)(customer.customerName), 1),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-link",
                                        onClick: ($event) => (switchCustomer(customer['@id']))
                                    }, _hoisted_6, 8, _hoisted_4),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-link",
                                        onClick: (0, vue_2.withModifiers)(($event) => (toggleFavouriteCustomer(customer)), ["stop"])
                                    }, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_8, (0, vue_2.toDisplayString)(isFavoriteCustomer(customer) ? "★" : "☆"), 1)
                                    ], 8, _hoisted_7)
                                ]));
                            }), 128))
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("no_favourite_customers", "No favourite customers found.", "switch_customer_modal")), 1)),
                    (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_search", "Customer search", "switch_customer_modal")), 1),
                    ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                        key: tableKey.value,
                        fields: switchCustomerListFields.value,
                        "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((switchCustomerListFields).value = $event)),
                        "sort-desc": sortDesc.value,
                        "onUpdate:sortDesc": _cache[1] || (_cache[1] = ($event) => ((sortDesc).value = $event)),
                        "sort-by": sortBy.value,
                        "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event) => ((sortBy).value = $event)),
                        "current-page": page.value,
                        "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event) => ((page).value = $event)),
                        "items-per-page": itemsPerPage.value,
                        "onUpdate:itemsPerPage": _cache[4] || (_cache[4] = ($event) => ((itemsPerPage).value = $event)),
                        items: (0, vue_2.unref)(customersStore).customers,
                        "total-items": (0, vue_2.unref)(customersStore).totalCustomers,
                        "is-busy": (0, vue_2.unref)(customersStore).loading,
                        striped: "",
                        condensed: "",
                        pagination: ""
                    }, {
                        "cell-actions": (0, vue_2.withCtx)(({ item: customer }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-link",
                                    onClick: ($event) => (switchCustomer(customer['@id']))
                                }, _hoisted_14, 8, _hoisted_12),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-link",
                                    onClick: (0, vue_2.withModifiers)(($event) => (toggleFavouriteCustomer(customer)), ["stop"])
                                }, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)(isFavoriteCustomer(customer) ? "★" : "☆"), 1)
                                ], 8, _hoisted_15)
                            ])
                        ]),
                        _: 1
                    }, 8, ["fields", "sort-desc", "sort-by", "current-page", "items-per-page", "items", "total-items", "is-busy"]))
                ]),
                _: 1
            }, 8, ["title", "is-open"]));
        };
    }
});
